// Bill of Materials (BOM) Helper, Presets & Utilities

export const TERMS_TEMPLATES = {
  ELECTRICAL_PANEL: [
    { clause_title: "PRICE", clause_content: "Above prices are Ex-works, Surat." },
    { clause_title: "SCOPE", clause_content: "Supply of Material only. Installation charges extra as actual." },
    { clause_title: "ON-SITE COMMISSIONING", clause_content: "Commissioning would be charged extra with lodging / boarding / food." },
    { clause_title: "VALIDITY", clause_content: "Our offer is valid for 30 Days from the date of this offer." },
    { clause_title: "DELIVERY", clause_content: "3-4 weeks after the receipt of confirmed order or approval of drawings whichever is later." },
    { clause_title: "TAXES & DUTIES", clause_content: "GST 18% is applicable extra as per government norms." },
    { clause_title: "PAYMENT", clause_content: "40% Advance along with Purchase Order. 60% against Proforma Invoice prior to dispatch." },
    { clause_title: "PACKING & FREIGHT", clause_content: "Freight exclusive on above quoted price. Standard Cardboard Box packing with Plastic Wrapping." },
    { clause_title: "WARRANTY", clause_content: "12 Months from the date of supply against manufacturing defects." },
    { clause_title: "LEGAL", clause_content: "All legal matters are subjected to Surat Jurisdiction." }
  ],
  FABRICATION_SUPPLY: [
    { clause_title: "MATERIAL SPECIFICATION", clause_content: "All raw materials shall conform to IS 2062 Grade E250 / E350 or client approved standards." },
    { clause_title: "FABRICATION TOLERANCES", clause_content: "Fabrication tolerances as per IS 7215 / IS 1852 standards." },
    { clause_title: "SURFACE PREPARATION", clause_content: "Shot/Grit blasting to Sa 2.5 profile followed by specified epoxy primer." },
    { clause_title: "INSPECTION & TESTING", clause_content: "Visual, DPT, MPT, UT / RT clearance as per agreed Quality Assurance Plan (QAP)." },
    { clause_title: "PRICE BASIS", clause_content: "Ex-Works Factory basis, exclusive of transport and insurance." },
    { clause_title: "DELIVERY SCHEDULE", clause_content: "Progressive delivery starting 4-6 weeks after drawing approval." },
    { clause_title: "PAYMENT TERMS", clause_content: "30% Advance, 70% against dispatch inspection clearance / proforma invoice." },
    { clause_title: "STATUTORY TAXES", clause_content: "GST @ 18% extra as applicable at the time of invoicing." }
  ],
  GENERAL_SUPPLY: [
    { clause_title: "PRICING", clause_content: "Prices quoted are net Ex-Works, Surat." },
    { clause_title: "VALIDITY", clause_content: "30 days from date of quotation." },
    { clause_title: "TAXES", clause_content: "GST applicable at current statutory rates." },
    { clause_title: "PAYMENT", clause_content: "100% advance or against proforma invoice before delivery." },
    { clause_title: "WARRANTY", clause_content: "Standard 1 year manufacturer warranty on all components." }
  ]
};

export const SPECIFICATION_PRESETS = {
  ELECTRICAL_PANEL: [
    {
      group_code: "AA",
      group_title: "Enclosure Details",
      parameters: [
        { parameter_name: "Type", details: "Indoor / Outdoor Type", type_value: "Indoor Type", unit: "" },
        { parameter_name: "Front", details: "Single Front / Double Front", type_value: "Single Front", unit: "" },
        { parameter_name: "Rating", details: "Current Rating up to", type_value: "0 up to 125A", unit: "" },
        { parameter_name: "Enclosure Make", details: "Panel Fabrication Make", type_value: "Creative Electricals", unit: "" },
        { parameter_name: "Ingress Protection", details: "IP Rating", type_value: "IP 42", unit: "" },
        { parameter_name: "Compartment", details: "Partitioning Type", type_value: "Compartmentalized Panel", unit: "" },
        { parameter_name: "Access", details: "Operational Access", type_value: "Front", unit: "" },
        { parameter_name: "Mounting", details: "Mounting Type", type_value: "Floor Mounted", unit: "" }
      ]
    },
    {
      group_code: "AB",
      group_title: "Cable Entry",
      parameters: [
        { parameter_name: "Cable Entry", details: "Trough / Gland Plate", type_value: "Detachable Gland plate", unit: "" },
        { parameter_name: "I/C Cables", details: "Incomer Cable Direction", type_value: "BOTTOM", unit: "" },
        { parameter_name: "O/G Cables", details: "Outgoing Cable Direction", type_value: "BOTTOM", unit: "" }
      ]
    },
    {
      group_code: "AC",
      group_title: "Construction Details",
      parameters: [
        { parameter_name: "Gland Plate", details: "Thickness & Sheet Material", type_value: "1.6mm CRCA, Removable Type", unit: "" },
        { parameter_name: "Panel Body / Load Bearing", details: "Structure Sheet Thickness", type_value: "1.6mm CRCA", unit: "" },
        { parameter_name: "Mounting Plate / Doors", details: "Door Sheet Thickness", type_value: "1.6mm CRCA", unit: "" },
        { parameter_name: "Partition Sheet", details: "Internal Partitions", type_value: "1.6mm CRCA", unit: "" },
        { parameter_name: "Base Frame", details: "Channel / Angle Size", type_value: "MS Angle Stand 35X35", unit: "" },
        { parameter_name: "Type of Hinges", details: "Hinge Mechanism", type_value: "Industrial Pin Type", unit: "" },
        { parameter_name: "Type of Ventilation", details: "Cooling & Airflow", type_value: "Louvers only", unit: "" },
        { parameter_name: "Lifting Mechanism", details: "Lifting provision", type_value: "Provision of hooks", unit: "" }
      ]
    },
    {
      group_code: "AD",
      group_title: "Painting Details",
      parameters: [
        { parameter_name: "Type of Paint", details: "Application Type", type_value: "Powder coating", unit: "" },
        { parameter_name: "Color Shade", details: "RAL Code & Finish", type_value: "RAL 7032 SIEMENS GRAY", unit: "" },
        { parameter_name: "Paint Process", details: "Chemical Pre-treatment", type_value: "7 Tank Process", unit: "" },
        { parameter_name: "Finishing", details: "Surface Texture", type_value: "Structure Finish", unit: "" },
        { parameter_name: "Plinth / Base Frame", details: "Base Frame Color", type_value: "Black", unit: "" }
      ]
    },
    {
      group_code: "AE",
      group_title: "Busbar Section",
      parameters: [
        { parameter_name: "Material", details: "Conductor Material", type_value: "Aluminum / Copper", unit: "" },
        { parameter_name: "Phase", details: "Phase Configuration", type_value: "TPN / FP", unit: "" },
        { parameter_name: "Current Carrying Density", details: "Density", type_value: "0.8A/Sq.mm. (Al) / 1.6A/Sq.mm. (Cu)", unit: "" },
        { parameter_name: "Breaking Capacity (kA)", details: "Fault Level", type_value: "36kA", unit: "" },
        { parameter_name: "Mechanical Property", details: "Bending Capability", type_value: "Bending up 90 degree without breaking", unit: "" },
        { parameter_name: "Busbar Insulation", details: "Sleeve Type", type_value: "Heat Shrinkable PVC Sleeve", unit: "" }
      ]
    },
    {
      group_code: "AF",
      group_title: "Busbar Clearance",
      parameters: [
        { parameter_name: "Phase to Phase", details: "Air Clearance", type_value: "25", unit: "Mm" },
        { parameter_name: "Phase to Neutral", details: "Air Clearance", type_value: "20", unit: "Mm" },
        { parameter_name: "Phase / Neutral to Earth", details: "Air Clearance", type_value: "20", unit: "Mm" },
        { parameter_name: "Busbar Insulation", details: "Insulation Sleeve", type_value: "Heat Shrinkable PVC Sleeve", unit: "" }
      ]
    },
    {
      group_code: "AG",
      group_title: "Busbar Supporter (Insulator)",
      parameters: [
        { parameter_name: "MOC", details: "Material of Composition", type_value: "DMC / SMC", unit: "" },
        { parameter_name: "Type", details: "Insulator Support Type", type_value: "Finger type / Standoff", unit: "" },
        { parameter_name: "Voltage Withstand Capacity", details: "Withstand Voltage", type_value: "1100 Volt", unit: "" }
      ]
    }
  ],
  STRUCTURAL_FABRICATION: [
    {
      group_code: "FA",
      group_title: "Raw Material & Standards",
      parameters: [
        { parameter_name: "Steel Grade", details: "Structural Steel", type_value: "IS 2062 E250 / E350", unit: "" },
        { parameter_name: "Plate Thickness Tolerance", details: "Rolling Tolerance", type_value: "As per IS 1852", unit: "" },
        { parameter_name: "Fastener Grade", details: "Bolts, Nuts & Washers", type_value: "Grade 8.8 / 10.9 (IS 1367)", unit: "" }
      ]
    },
    {
      group_code: "FB",
      group_title: "Welding & NDT",
      parameters: [
        { parameter_name: "Welding Process", details: "WPS / PQR Standard", type_value: "GMAW / FCAW / SMAW (AWS D1.1)", unit: "" },
        { parameter_name: "Welding Electrode Make", details: "Approved Brands", type_value: "ESAB / ADOR / D&H", unit: "" },
        { parameter_name: "NDT Extent", details: "Testing Requirements", type_value: "100% Visual, 20% DPT, 10% UT", unit: "" }
      ]
    },
    {
      group_code: "FC",
      group_title: "Surface Preparation & Coating",
      parameters: [
        { parameter_name: "Blast Profile", details: "Surface Cleanliness", type_value: "Grit Blast Sa 2.5 (35-50 microns)", unit: "" },
        { parameter_name: "Primer Coat", details: "Zinc Rich Epoxy", type_value: "1 Coat @ 75 microns DFT", unit: "" },
        { parameter_name: "Intermediate Coat", details: "High Build Epoxy (MIO)", type_value: "1 Coat @ 100 microns DFT", unit: "" },
        { parameter_name: "Finish Coat", details: "Aliphatic Polyurethane (PU)", type_value: "1 Coat @ 50 microns DFT", unit: "" }
      ]
    }
  ]
};

export const formatINR = (val) => {
  const num = Number(val || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  return "₹ " + num;
};

export const formatNumber = (val) => {
  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(val || 0);
};

export const numberToWords = (num) => {
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  if (num === 0) return 'Zero Rupees Only';

  const n = ('000000000' + num).slice(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return '';

  let str = '';

  const getTwoDigit = (val) => {
    val = Number(val);
    if (val < 20) return a[val];
    return b[Math.floor(val / 10)] + (val % 10 ? ' ' + a[val % 10] : '');
  };

  if (Number(n[1])) str += getTwoDigit(n[1]) + ' Crore ';
  if (Number(n[2])) str += getTwoDigit(n[2]) + ' Lakh ';
  if (Number(n[3])) str += getTwoDigit(n[3]) + ' Thousand ';
  if (Number(n[4])) str += a[Number(n[4])] + ' Hundred ';

  if (Number(n[5])) {
    str += (str !== '' ? 'and ' : '') + getTwoDigit(n[5]) + ' ';
  }

  return str.trim() + ' Rupees Only';
};

